import React from 'react';
import { SvgIconProps, SvgIcon } from '@mui/material';

const PLetter = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 10.6667C12 11.0203 11.8595 11.3594 11.6095 11.6095C11.3594 11.8595 11.0203 12 10.6667 12H1.33333C0.979711 12 0.640573 11.8595 0.390524 11.6095C0.140476 11.3594 0 11.0203 0 10.6667V1.33333C0 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979711 0 1.33333 0L10.6667 0C11.0203 0 11.3594 0.140476 11.6095 0.390524C11.8595 0.640573 12 0.979711 12 1.33333V10.6667Z"
          fill="var(--mui-palette-primary-main)"
        />
        <path
          d="M3.59375 3.11398C3.59375 2.62798 3.88308 2.30798 4.40008 2.30798H6.22942C7.74908 2.30798 8.87542 3.30032 8.87542 4.77798C8.87542 6.28698 7.70742 7.22765 6.29175 7.22765H5.14475V8.92265C5.14475 9.43965 4.81408 9.72865 4.36942 9.72865C3.92475 9.72865 3.59408 9.43965 3.59408 8.92265L3.59375 3.11398ZM5.14408 5.86332H6.19808C6.84942 5.86332 7.26275 5.38798 7.26275 4.76765C7.26275 4.14732 6.84942 3.67198 6.19808 3.67198H5.14408V5.86332Z"
          fill="var(--mui-palette-common-white)"
        />
      </svg>
    </SvgIcon>
  );
};

export default PLetter;
